"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gualdo-cattaneo": {
    "fbff0d50": [{
      "hkey": "e7264c89",
      "slug": "gualdo-cattaneo",
      "name": "Gualdo Cattaneo",
      "primary": true,
      "skipSearch": false
    }],
    "ceralto": [{
      "hkey": "e7264c89",
      "slug": "gualdo-cattaneo",
      "name": "Gualdo Cattaneo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af135cd8": [{
      "hkey": "e7264c89",
      "slug": "gualdo-cattaneo",
      "name": "Gualdo Cattaneo",
      "primary": true,
      "skipSearch": false
    }],
    "cisterna": [{
      "hkey": "e7264c89",
      "slug": "gualdo-cattaneo",
      "name": "Gualdo Cattaneo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5cadfd74": [{
      "hkey": "787843d9",
      "slug": "collesecco-marcellano",
      "name": "Collesecco-Marcellano",
      "primary": true,
      "skipSearch": false
    }],
    "collesecco": [{
      "hkey": "787843d9",
      "slug": "collesecco-marcellano",
      "name": "Collesecco-Marcellano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gualdo-cattaneo"
    }],
    "6fe62470": [{
      "hkey": "787843d9",
      "slug": "collesecco-marcellano",
      "name": "Collesecco-Marcellano",
      "primary": true,
      "skipSearch": false
    }],
    "marcellano": [{
      "hkey": "787843d9",
      "slug": "collesecco-marcellano",
      "name": "Collesecco-Marcellano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;